import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
// import { NgbTabset, NgbTabsetConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbNav, NgbNavConfig } from '@ng-bootstrap/ng-bootstrap';
import { ColumnChooserService, GridComponent, PageService, ToolbarService, VirtualScrollService, SortService, FilterService, SearchService } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations/src';
import { ToastrService } from 'ngx-toastr';
import { fadeInOut } from '../../shared/helpers/animations';
import { ICompanyContactStatus, IContact, IDashboardRequest, IPaginatedResult, createDefaultDashboardRequest } from '../../shared/models/index';
import { AuthorizationService, CompanyContactService, StorageManagerService } from '../../shared/services/index';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { DeleteButtonComponent } from '../common/delete-button/delete-button.component';
import { Utilities } from '../../shared/services/utilities';

@Component({
    selector: 'app-contact-dashboard',
    templateUrl: './contact-dashboard.component.html',
    styleUrls: ['./contact-dashboard.component.scss'],
    providers: [ToolbarService, ColumnChooserService, PageService, VirtualScrollService, SortService, FilterService, SearchService],
    animations: [fadeInOut],
    standalone: false
})

export class ContactDashboardComponent implements OnInit, AfterViewInit {

  @ViewChild('contact_grid')
  public contactGrid: GridComponent;
  @ViewChild('drafts_grid')
  public draftsGrid: GridComponent;
  @ViewChild('ngbNav', { static: true })
  public tabset: NgbNav;
  @ViewChild('tooltip')
  public tooltip: TooltipComponent;
  @ViewChild('deleteContact')
  public deleteButton: DeleteButtonComponent;
  @ViewChild('deleteDraftContact')
  public deleteButtonDrafts: DeleteButtonComponent;

  // Initialize with empty server-side format for Syncfusion grid
  public contact_grid_data: any = { result: [], count: 0 };
  public drafts_grid_data: any = { result: [], count: 0 };
  public initialPage: Object;
  // Separate page settings for each grid to track server-side totals
  public contactPageSettings: Object;
  public draftsPageSettings: Object;
  public toolbarOptions: Object;
  errorMessage: string;
  count_contact: number;
  count_drafts: number;
  FORM_STATUS_ACTIVE = 'A';
  contactStatus: ICompanyContactStatus;
  loading = true;
  loadingDrafts = true;
  public formatOptions: any;
  activeTab: string;
  sub: Subscription;
  public clipmodecolumn = { class: 'e-tooltipcolumn' };
  selectedContactRevisionId: number | undefined;
  hasWritePermission = false;
  hasDeletePermission = false;

  // Server-side pagination state for contacts
  contactRequest: IDashboardRequest;
  // Server-side pagination state for drafts
  draftsRequest: IDashboardRequest;

  /**
   * Explicit selection persistence across paging/sorting/filtering.
   */
  private selectedContactRevisionIds = {
    contact: null as number | null,
    drafts: null as number | null
  };

  private readonly dateFilterKeys: { [key: string]: { from: string; to: string } } = {
    modified: { from: 'modifiedFrom', to: 'modifiedTo' }
  };

  constructor(private router: Router, private companySvc: CompanyContactService, private toastr: ToastrService,
    private sanitizer: DomSanitizer, private storageManagerService: StorageManagerService, private authorizationService: AuthorizationService) {
  }

    ngOnInit(): void {
        this.checkUserPermission();

        this.toolbarOptions = this.createCustomToolbarItems(this.hasDeletePermission, this.hasWritePermission);

        this.initialPage = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100] };
        // Initialize separate page settings for each grid
        this.contactPageSettings = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100] };
        this.draftsPageSettings = { currentPage: 1, pageSize: 25, pageSizes: [25, 50, 75, 100] };
        this.formatOptions = { type: 'dateTime', format: Utilities.getLocaleDateString() + ' hh:mm a' };

        // Initialize server-side pagination requests
        this.contactRequest = createDefaultDashboardRequest(false);
        this.contactRequest.pageSize = 25;
        this.contactRequest.sortColumn = 'modified';
        this.contactRequest.sortDirection = 'DESC';
        this.draftsRequest = createDefaultDashboardRequest(true);
        this.draftsRequest.pageSize = 25;
        this.draftsRequest.sortColumn = 'modified';
        this.draftsRequest.sortDirection = 'DESC';

        // clear out previously saved info
        sessionStorage['currentContactId'] = null;

      // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
      this.initTabIndex();

      // Load both contacts and drafts with server-side pagination
      this.loadContacts();
      this.loadDrafts();

      this.activeTab = 'contact';

      // Fix for footer spacing issues
      document.getElementsByTagName('footer')[0].classList.add("footer-spacing-fix");
    }

    ngAfterViewInit(): void {
      this.syncGridSpinners();
    }

    initTabIndex() {
      (document.activeElement as HTMLElement).blur();

      const main = document.getElementById('firstDiv');

      if (main) {
        main.focus();
      }
    }

    createCustomToolbarItems(deletePermission : boolean, writePermission: boolean) {
        let toolbarItems = [];

        if (writePermission) {
            toolbarItems.push(
                {
                    text: 'Create New Contact',
                    tooltipText: 'Add a new contact to this list',
                    prefixIcon: 'fas fa-plus',
                    id: 'create-form-btn'
                }
            );
        }

        if(deletePermission){
            toolbarItems.push(
                {
                    text: 'Delete Contact',
                    tooltipText: 'Delete the selected contact',
                    prefixIcon: 'fas fa-trash',
                    id: 'tool-bar-delete'
                }
            )
        }

        toolbarItems.push('Search');

        return toolbarItems;
      }

    checkUserPermission() {
        if (this.authorizationService.hasPermission('SSDP.CanWriteContact')) {
          this.hasWritePermission = true;
        }
        if (this.authorizationService.hasPermission('SSDP.CanDeleteContact')) {
            this.hasDeletePermission = true;
        }
    }

    tabChanged(event) {
      this.activeTab = event.nextId;
      this.selectedContactRevisionId = undefined;

      // restore selection when switching tabs
      setTimeout(() => this.restoreSelectionForActiveTab());
      setTimeout(() => this.syncGridSpinners());
  }

  tooltipValue(args) {

    let grid;

    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {

      switch (this.activeTab) {
        case 'drafts':
          grid = this.draftsGrid;
          break;
        case 'contact':
          grid = this.contactGrid;
          break;
      }

      const rowInfo = grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltip.cssClass = 'customTooltip';
      this.tooltip.content = rowData[(rowInfo.column as any).field];
    }
  }

    // Grid toolbar click event handler
    toolbarClick(args: ClickEventArgs): void {
        if (args.item.id === 'create-form-btn') {
            this.router.navigate(['contact']);
        }
        if (args.item.id === 'tool-bar-delete' && this.selectedContactRevisionId) {
            if(this.contactGrid){
                this.deleteButton.revisionId = this.selectedContactRevisionId.toString();
                this.deleteButton.openDeleteModal();
            }
            else if(this.draftsGrid){
                this.deleteButtonDrafts.revisionId = this.selectedContactRevisionId.toString();
                this.deleteButtonDrafts.openDeleteModal();
            }
        }
    }

    // Load contacts with server-side pagination
    loadContacts() {
        this.loading = true;
        this.setGridLoading(this.contactGrid, true);
        this.companySvc.GetContactDashboardPaginated(this.contactRequest).subscribe(
            (result: IPaginatedResult<IContact>) => {
                // Ensure result has required properties with safe defaults
                const pageNumber = result?.pageNumber ?? 1;
                const pageSize = result?.pageSize ?? 25;
                const totalRecords = result?.totalRecords ?? 0;
                const data = result?.data ?? [];

                this.count_contact = totalRecords;

                this.contact_grid_data = { result: data, count: totalRecords };
                this.loading = false;
                this.setGridLoading(this.contactGrid, false);
            },
            error => {
                this.loading = false;
                this.setGridLoading(this.contactGrid, false);
                this.toastr.error(error.message || 'Failed to load contacts');
            }
        );
    }

    // Load drafts with server-side pagination
    loadDrafts() {
        this.loadingDrafts = true;
        this.setGridLoading(this.draftsGrid, true);
        this.companySvc.GetContactDashboardPaginated(this.draftsRequest).subscribe(
            (result: IPaginatedResult<IContact>) => {
                // Ensure result has required properties with safe defaults
                const pageNumber = result?.pageNumber ?? 1;
                const pageSize = result?.pageSize ?? 25;
                const totalRecords = result?.totalRecords ?? 0;
                const data = result?.data ?? [];

                this.count_drafts = totalRecords;

                this.drafts_grid_data = { result: data, count: totalRecords };
                this.loadingDrafts = false;
                this.setGridLoading(this.draftsGrid, false);
            },
            error => {
                this.loadingDrafts = false;
                this.setGridLoading(this.draftsGrid, false);
                this.toastr.error(error.message || 'Failed to load drafts');
            }
        );
    }

    private syncGridSpinners(): void {
        this.setGridLoading(this.contactGrid, this.loading);
        this.setGridLoading(this.draftsGrid, this.loadingDrafts);
    }

    private setGridLoading(grid: GridComponent | undefined, isLoading: boolean): void {
        setTimeout(() => {
            if (!grid) {
                return;
            }

            if (isLoading) {
                grid.showSpinner();
            } else {
                grid.hideSpinner();
            }
        });
    }

    // Handle actionBegin - change filter operator from "startswith" to "contains"
    // and handle filtering server-side
    public begin(args: any): void {
        if (args.requestType === 'filtering') {
            // Change operator from "startswith" to "contains" for text columns
            if (args.columns) {
                args.columns.forEach(col => {
                    if (col.field !== 'modified') {
                        col.operator = 'contains';
                    }
                });
            }
            // Don't cancel - let dataStateChange handle the actual filtering
        }
    }

    viewContact(contactRevisionId: string, contactId: string) {
        if (contactRevisionId) {

            this.router.navigate(['contact', contactRevisionId]);
        }
    }

    contactGridRowSelected(e: any) {
        const id = e?.data?.contactRevisionId;
        this.selectedContactRevisionId = id;
        if (this.activeTab === 'drafts') {
            this.selectedContactRevisionIds.drafts = id;
        } else {
            this.selectedContactRevisionIds.contact = id;
        }
    }

    contactGridRowDeselected() {
        this.selectedContactRevisionId = undefined;
        if (this.activeTab === 'drafts') {
            this.selectedContactRevisionIds.drafts = null;
        } else {
            this.selectedContactRevisionIds.contact = null;
        }
    }

    // Handle contact grid data state changes (paging, sorting, searching, filtering)
    onContactDataStateChange(state: any): void {
        // Skip initial data load (handled by ngOnInit) - no action or refresh without search
        if (!state.action || (state.action.requestType === 'refresh' && !state.action.searchString)) {
            return;
        }
        this.updateRequestFromState(this.contactRequest, state);
        this.loadContacts();
    }

    // Handle drafts grid data state changes (paging, sorting, searching, filtering)
    onDraftsDataStateChange(state: any): void {
        // Skip initial data load (handled by ngOnInit) - no action or refresh without search
        if (!state.action || (state.action.requestType === 'refresh' && !state.action.searchString)) {
            return;
        }
        this.updateRequestFromState(this.draftsRequest, state);
        this.loadDrafts();
    }

    // Update the pagination request based on Syncfusion grid state (paging, sorting, searching, filtering)
    private updateRequestFromState(request: IDashboardRequest, state: any): void {
        // Handle paging - use skip and take from dataStateChange
        if (state.skip !== undefined && state.take !== undefined) {
            request.pageNumber = Math.floor(state.skip / state.take) + 1;
            request.pageSize = state.take;
        }

        // Handle sorting
        if (state.sorted && state.sorted.length > 0) {
            const sortInfo = state.sorted[0];
            request.sortColumn = sortInfo.name;
            request.sortDirection = sortInfo.direction === 'descending' ? 'DESC' : 'ASC';
        } else if (state.action && state.action.requestType === 'sorting') {
            // Also check action for sorting info
            if (state.action.columnName) {
                request.sortColumn = state.action.columnName;
                request.sortDirection = state.action.direction === 'Descending' ? 'DESC' : 'ASC';
            } else {
                request.sortColumn = '';
                request.sortDirection = 'ASC';
            }
        }

        // Handle searching from dataStateChange
        if (state.search && state.search.length > 0) {
            request.searchTerm = state.search[0].key || '';
            request.pageNumber = 1; // Reset to first page on new search
        } else if (state.action && state.action.requestType === 'searching') {
            // Handle searching from action event
            request.searchTerm = state.action.searchString || '';
            request.pageNumber = 1; // Reset to first page on new search
        } else if (!state.search || state.search.length === 0) {
            // Clear search term when no search is active
            if (request.searchTerm) {
                request.searchTerm = '';
                request.pageNumber = 1;
            }
        }

        // Handle filtering from dataStateChange - rebuild filters from state.where
        if (state.action && (state.action.requestType === 'filtering' || state.action.requestType === 'clearfiltering')) {
            const newFilters: { [key: string]: string } = {};

            if (state.where && state.where.length > 0) {
                state.where.forEach(condition => {
                    if (condition.predicates && condition.predicates.length > 0) {
                        condition.predicates.forEach(pred => {
                            if (pred.field && pred.value !== undefined && pred.value !== null && pred.value !== '') {
                                this.addColumnFilter(newFilters, pred.field, pred.value, pred.operator);
                            }
                        });
                    } else if (condition.field && condition.value !== undefined && condition.value !== null && condition.value !== '') {
                        this.addColumnFilter(newFilters, condition.field, condition.value, condition.operator);
                    }
                });
            }

            request.columnFilters = newFilters;
            request.pageNumber = 1;
        }
    }

    private addColumnFilter(filters: { [key: string]: string }, field: string, value: any, operator?: string): void {
        if (!field || value === undefined || value === null || value === '') {
            return;
        }

        const dateKeys = this.dateFilterKeys[field];
        if (dateKeys) {
            const dateValue = this.formatFilterDate(value);
            if (!dateValue) {
                return;
            }

            const normalizedOperator = (operator || 'equal').toLowerCase();
            if (normalizedOperator.indexOf('greater') >= 0) {
                filters[dateKeys.from] = dateValue;
            } else if (normalizedOperator.indexOf('less') >= 0) {
                filters[dateKeys.to] = dateValue;
            } else {
                filters[dateKeys.from] = dateValue;
                filters[dateKeys.to] = dateValue;
            }
            return;
        }

        if (field === 'version') {
            filters[field] = `${value}.0`;
        } else {
            filters[field] = String(value);
        }
    }

    private formatFilterDate(value: any): string {
        let date: Date;

        if (value instanceof Date) {
            date = value;
        } else {
            date = new Date(value);
        }

        if (isNaN(date.getTime())) {
            return '';
        }

        const month = `${date.getMonth() + 1}`.padStart(2, '0');
        const day = `${date.getDate()}`.padStart(2, '0');
        return `${date.getFullYear()}-${month}-${day}`;
    }

    /** Called by the grids after paging/sorting/filtering so we can reselect the row. */
    gridActionComplete(args: any) {
        switch (args?.requestType) {
            case 'paging':
            case 'sorting':
            case 'filtering':
            case 'searching':
            case 'refresh':
                this.restoreSelectionForActiveTab();
                break;
        }
    }

    private restoreSelectionForActiveTab() {
        const grid = this.activeTab === 'drafts' ? this.draftsGrid : this.contactGrid;
        const id = this.activeTab === 'drafts' ? this.selectedContactRevisionIds.drafts : this.selectedContactRevisionIds.contact;

        if (!grid || !id) {
            return;
        }

        const view = grid.getCurrentViewRecords() as any[];

        let rowIndex = -1;
        if (view && view.length) {
            for (let i = 0; i < view.length; i++) {
                if (view[i] && view[i].contactRevisionId === id) {
                    rowIndex = i;
                    break;
                }
            }
        }

        if (rowIndex >= 0) {
            grid.selectRow(rowIndex);
        }
    }
}

